import React from "react";
import {useState} from "react";
import { Field } from "react-final-form";
import { Tooltip } from "reactstrap";

import * as Utils from "../../../utils";

const CustomFieldForm: React.FC<any> = (props: any) => {
    const predefinedValues: string[] = props.item.predefinedValues && props.item.predefinedValues.length ? props.item.predefinedValues.split(";") : null;
    const [customFieldTooltipOpen, setCustomFieldTooltipOpen] = useState<boolean>(false);
    const customFieldToggle = () => setCustomFieldTooltipOpen(!customFieldTooltipOpen);
    const name:string = props.item.scope === Utils.transactionField ? "custom" + props.item.oid : props.customOid;

    return (
        <div className="form-group">
            {
                // Label
                props.item.type !== 2 && (
                    <label
                        className="col-form-label"
                        id={"custom" + props.item.oid}
                    >
                        {props.item.caption} {props.item.required && <strong>*</strong>}
                    </label>
                )
            }

            {
                // Custom Field Type 0 -> Single line
                props.item.type === 0 && (
                    <Field
                        id={"custom" + props.item.oid}
                        name={name}
                        component="input"
                        type="text"
                        className={props.validateForm && !props.form.getFieldState(name)?.value && props.item.required
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        validate={props.item.required ? Utils.required : undefined}
                    />
                )
            }

            {
                // Custom Field Type 1 -> Multi line
                props.item.type === 1 && (
                    <Field
                        id={"custom" + props.item.oid}
                        name={name}
                        component="textarea"
                        type="textarea"
                        className={props.validateForm && !props.form.getFieldState(name)?.value && props.item.required
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        validate={props.item.required ? Utils.required : undefined}
                    />
                )
            }

            {
                // Custom Field Type 2 -> Boolean
                props.item.type === 2 && (
                    <label
                        className="col-form-label"
                        id={"custom" + props.item.oid}
                    >
                        <Field
                            id={"custom" + props.item.oid}
                            name={name}
                            component="input"
                            type="checkbox"
                            value="checked"
                        />{" "}
                        {props.item.caption} {props.item.required && <strong>*</strong>}
                    </label>
                )
            }

            {
                // Custom Field Type 3 -> Dropdown
                props.item.type === 3 && (
                    <Field
                        id={"custom" + props.item.oid}
                        name={name}
                        component="select"
                        className={props.validateForm && !props.form.getFieldState(name)?.value && props.item.required
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        validate={props.item.required ? Utils.required : undefined}
                        defaultValue={predefinedValues.length === 1 ? predefinedValues[0] : undefined}
                    >
                        {predefinedValues.length > 1 && <option value={undefined}>Seleccioneu una opció</option>}
                        {predefinedValues.map((item: string, i: number) => {
                            return <option key={i} value={item}>{item}</option>
                        })}
                    </Field>
                )
            }

            {
                // Custom Field Type 4 -> Date
                props.item.type === 4 && (
                    <Field
                        id={"custom" + props.item.oid}
                        name={name}
                        component="input"
                        type="date"
                        className={props.validateForm && !props.form.getFieldState(name)?.value && props.item.required
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        validate={props.item.required ? Utils.required : undefined}
                    />
                )
            }

            {
                // Custom Field Type 5 -> Integer
                props.item.type === 5 && (
                    <Field
                        id={"custom" + props.item.oid}
                        name={name}
                        component="input"
                        type="number"
                        min={0}
                        className={props.validateForm && !props.form.getFieldState(name)?.value && props.item.required
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        validate={props.item.required ? Utils.required : undefined}
                    />
                )
            }

            <Tooltip
                placement="top"
                isOpen={customFieldTooltipOpen}
                target={"custom" + props.item.oid}
                toggle={customFieldToggle}
                hideArrow={true}
                style={{ backgroundColor: "#7c7c7c" }}
            >
                {props.item.toolTip}
            </Tooltip>
            
            <div className="invalid-feedback">
                {props.form.getFieldState(name) &&
                props.form.getFieldState(name)?.error}
            </div>
        </div>
    )
};

export default CustomFieldForm;